import { render, staticRenderFns } from "./IncomingVideocall.vue?vue&type=template&id=6c3630d8&scoped=true"
import script from "./IncomingVideocall.vue?vue&type=script&lang=js"
export * from "./IncomingVideocall.vue?vue&type=script&lang=js"
import style0 from "./IncomingVideocall.vue?vue&type=style&index=0&id=6c3630d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3630d8",
  null
  
)

export default component.exports